<template>
    <md-dialog :md-active.sync="active" :md-close-on-esc="false"
    :md-click-outside-to-close="false">
    <md-dialog-title>{{ i18n.lbl_sub() }} - {{ values.Description }}</md-dialog-title>
    <detail :prop="i18n.lbl_exchange_asset()"  :value="values.Asset"/>
    <detail :prop="i18n.lbl_balance()"  :value="values.Balance"/>
    <detail :prop="i18n.lbl_my_wallet()"  :value="values.WalletId"/>
    <detail :prop="i18n.lbl_user()"  :value="values.UserId"/>
    <md-dialog-actions>
        <md-button class="md-button btn md-primary md-theme-default" @click="close" :disabled="isLoading">{{ i18n.lbl_cancel() }}</md-button>
        <md-button class="md-button btn md-primary md-theme-default" @click="deleteWallet" :disabled="isLoading">{{ i18n.lbl_delete() }}</md-button>
        <md-button class="md-button btn md-primary md-theme-default" @click="transfetToWallet" :disabled="isLoading">{{ i18n.lbl_sub_transfer() }}</md-button>
        <md-button class="md-button btn md-primary md-theme-default" @click="setChange" :disabled="isLoading">{{ i18n.lbl_sub_edit() }}</md-button>
    </md-dialog-actions>
    </md-dialog>
</template>
    
<script>
/* eslint-disable */
import Detail from '@vue/app/common/Detail.Row'
import { i18n } from '@js/i18n'

export default {
  name: 'DeleteSubwalletModal',
  components: {Detail},
  data () {
    return {
      i18n,
      isLoading: false
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'deleteSubWallet', 'setActiveChange'],
  methods: {
    close () {
      this.$emit('close', {})
    },
    async deleteWallet () {
      this.isLoading = true
      await this.$emit('deleteSubWallet', this.values.WalletId)
      this.close()
      this.isLoading = false
    },
    transfetToWallet () {
      this.$emit('close', {...this.values, transfer: this.values.WalletId})
    },
    setChange () {
      this.$emit('close', {...this.values, edit: this.values.WalletId})
    }
  }
}
</script>

<style scoped lang="scss">
.md-title {
    padding-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/vue/app/dashboard/index/DeleteSubwalletModal.vue